import { render, staticRenderFns } from "./leftBox.vue?vue&type=template&id=66adc4b8&scoped=true"
import script from "./leftBox.vue?vue&type=script&lang=js"
export * from "./leftBox.vue?vue&type=script&lang=js"
import style0 from "./leftBox.vue?vue&type=style&index=0&id=66adc4b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66adc4b8",
  null
  
)

export default component.exports